export const ROLES = {
	ADMIN: "admin",
	PRODUCE_ADMIN: "produce-admin",
	RESTOCK_ORDERER: "restock-orderer",
	SUPER_ADMIN: "superadmin",
	VERIFY_MANAGER: "verify-manager",
	VERIFY_SCANNER: "verify-scanner"
} as const;
